/**
 * AI Agents Routes Configuration
 *
 * Routes for AI-powered features including admin chatbot, knowledge base,
 * and dashboard. VDB Management and Agents Management have been moved to app-admin module.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Lazy load components for better performance
const AdminChatbot = lazy(() => import('../admin-chatbot'));
const Dashboard = lazy(() => import('../dashboard'));

// AI Agents child routes
export const aiAgentsChildRoutes: RouteObject[] = [
  {
    index: true,
    element: <AdminChatbot />
  },
  {
    path: 'dashboard',
    element: <Dashboard />
  }
];

export default aiAgentsChildRoutes;
